// import React, { useState, useEffect } from 'react';
// import { getData, postData, putData, deleteData } from '../../../Services/Fetchnodeservices';

// // ===================== ICONS =====================
// const ChevronLeftIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//     <polyline points="15 18 9 12 15 6"/>
//   </svg>
// );
// const ChevronRightIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//     <polyline points="9 18 15 12 9 6"/>
//   </svg>
// );
// const SendIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
//   </svg>
// );
// const CloseIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//   </svg>
// );
// const ResolveIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <polyline points="20 6 9 17 4 12"/>
//   </svg>
// );

// // ===================== THEME =====================
// const getT = (isDark) => ({
//   bg: isDark ? "#0c1018" : "#f0f4ff",
//   surface: isDark ? "#141824" : "#ffffff",
//   surfaceAlt: isDark ? "#1c2133" : "#f4f7ff",
//   border: isDark ? "rgba(255,255,255,0.07)" : "#e2e8f5",
//   text: isDark ? "#f1f5f9" : "#0f172a",
//   textMuted: isDark ? "#64748b" : "#94a3b8",
//   textSub: isDark ? "#94a3b8" : "#64748b",
//   accent: "#6c63ff",
//   success: "#22c55e",
//   danger: "#ef4444",
//   info: "#3b82f6",
// });

// // ===================== SUB-COMPONENTS =====================
// const Card = ({ children, style, onClick }) => (
//   <div onClick={onClick} style={{ ...style, transition: "all 0.3s ease", cursor: onClick ? "pointer" : "default" }}>{children}</div>
// );

// const StatusBadge = ({ status, isDark }) => {
//   const configs = {
//     open: { bg: "rgba(239,68,68,0.15)", color: "#ef4444", label: "Open" },
//     pending: { bg: "rgba(245,158,11,0.15)", color: "#f59e0b", label: "Pending" },
//     in_progress: { bg: "rgba(59,130,246,0.15)", color: "#3b82f6", label: "In Progress" },
//     resolved: { bg: "rgba(34,197,94,0.15)", color: "#22c55e", label: "Resolved" },
//     closed: { bg: "rgba(148,163,184,0.15)", color: "#94a3b8", label: "Closed" },
//   };
//   const config = configs[status] || configs.pending;
//   return <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: config.bg, color: config.color }}>{config.label}</span>;
// };

// const TicketCard = ({ ticket, onClick, isDark }) => {
//   const t = getT(isDark);
//   return (
//     <div onClick={() => onClick(ticket)} style={{
//       background: t.surface,
//       border: `1px solid ${t.border}`,
//       borderRadius: "14px",
//       padding: "16px",
//       cursor: "pointer",
//       transition: "all 0.2s",
//       marginBottom: "12px"
//     }}>
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "12px" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#1e3a8a", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: 600, color: "#fff" }}>{ticket.user_id}</div>
//           <div>
//             <div style={{ fontWeight: 600, fontSize: "14px", color: t.text }}>{ticket.user_table === 'restaurants' ? 'Restaurant' : 'User'} #{ticket.user_id}</div>
//             <div style={{ fontSize: "11px", color: t.textMuted }}>{new Date(ticket.created_at).toLocaleString()}</div>
//           </div>
//         </div>
//         <StatusBadge status={ticket.ticketstatus} isDark={isDark} />
//       </div>
//       <div style={{ marginBottom: "10px" }}>
//         <div style={{ fontWeight: 600, fontSize: "13px", color: t.text, marginBottom: "4px" }}>{ticket.subject}</div>
//         <p style={{ fontSize: "11px", color: t.textMuted, margin: 0 }}>{ticket.description.substring(0, 70)}...</p>
//       </div>
//     </div>
//   );
// };

// // ===================== MAIN COMPONENT =====================
// const SupportSystem = ({ isDark = true, restaurantId = null, isAdmin = false }) => {
//   const t = getT(isDark);
//   const [tickets, setTickets] = useState([]);
//   const [selectedTicket, setSelectedTicket] = useState(null);
//   const [showTicketModal, setShowTicketModal] = useState(false);
//   const [search, setSearch] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [userTable, setUserTable] = useState('restaurants');

//   // Fetch tickets – CORRECT API BASE = 'supportRoutes'
//   const fetchTickets = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const params = new URLSearchParams();

//       // Admin sees all tickets (no user_id filter)
//       // Restaurant sees only its own tickets
//       if (!isAdmin && restaurantId) {
//         params.append('user_table', 'restaurants');
//         params.append('user_id', restaurantId);
//       } else if (isAdmin) {
//         // Admin can optionally filter by user_table, e.g., 'restaurants', 'users', 'riders'
//         if (userTable) params.append('user_table', userTable);
//       } else {
//         // no restaurantId and not admin – error
//         setError('Restaurant ID missing or admin mode not set');
//         return;
//       }

//       if (search) params.append('search', search);
//       if (statusFilter !== 'all') params.append('status', statusFilter);

//       const url = `supportRoutes/?${params.toString()}`;
//       console.log('🔍 Fetching tickets from:', url);
//       const data = await getData(url);
//       console.log('📦 API response:', data);
//       if (data.success) {
//         setTickets(data.data);
//       } else {
//         setError('Failed to load tickets');
//       }
//     } catch (err) {
//       console.error('Fetch error:', err);
//       setError('Network error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // Only fetch if we have either restaurantId or isAdmin=true
//     if (restaurantId || isAdmin) {
//       fetchTickets();
//     } else {
//       setError('No valid user context to fetch tickets');
//     }
//   }, [restaurantId, isAdmin, search, statusFilter, userTable]);

//   // Stats
//   const stats = {
//     total: tickets.length,
//     open: tickets.filter(t => t.ticketstatus === 'open').length,
//     inProgress: tickets.filter(t => t.ticketstatus === 'in_progress').length,
//     resolved: tickets.filter(t => t.ticketstatus === 'resolved').length,
//   };

//   const paginatedTickets = tickets.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
//   const totalPages = Math.ceil(tickets.length / itemsPerPage);

//   // Handlers – CORRECT PUT URL
//   const handleReply = async (ticketId, reply) => {
//     try {
//       const ticket = tickets.find(t => t.id === ticketId);
//       if (!ticket) return;
//       const newDesc = ticket.description + "\n\n[Admin Reply]: " + reply;
//       const data = await putData(`supportRoutes/${ticketId}`, {
//         ticketstatus: 'in_progress',
//         description: newDesc
//       });
//       if (data.success) {
//         fetchTickets();
//         setShowTicketModal(false);
//         alert('Reply sent');
//       }
//     } catch (err) {
//       alert('Failed to send reply');
//     }
//   };

//   const handleResolve = async (ticketId) => {
//     try {
//       const data = await putData(`supportRoutes/${ticketId}`, { ticketstatus: 'resolved' });
//       if (data.success) {
//         fetchTickets();
//         setShowTicketModal(false);
//         alert('Ticket resolved');
//       }
//     } catch (err) {
//       alert('Failed to resolve');
//     }
//   };

//   // Modal
//   const TicketDetailModal = ({ ticket, onClose }) => {
//     const [replyText, setReplyText] = useState('');
//     return (
//       <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
//         <div onClick={e => e.stopPropagation()} style={{ background: t.surface, borderRadius: '20px', width: '550px', maxWidth: '100%', maxHeight: '85vh', overflowY: 'auto', border: `1px solid ${t.border}` }}>
//           <div style={{ padding: '20px 24px', borderBottom: `1px solid ${t.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: t.surfaceAlt }}>
//             <div><h2 style={{ margin: 0, fontSize: '18px', color: t.text }}>Ticket #{ticket.id}</h2><p style={{ margin: '4px 0 0', fontSize: '12px', color: t.textMuted }}>{ticket.subject}</p></div>
//             <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: t.textMuted }}><CloseIcon /></button>
//           </div>
//           <div style={{ padding: '20px' }}>
//             <div style={{ marginBottom: '16px' }}>
//               <StatusBadge status={ticket.ticketstatus} isDark={isDark} />
//               <span style={{ marginLeft: '12px', fontSize: '13px', color: t.textMuted }}>Created: {new Date(ticket.created_at).toLocaleString()}</span>
//             </div>
//             <div style={{ marginBottom: '20px' }}>
//               <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: t.text }}>Description</h4>
//               <p style={{ margin: 0, fontSize: '13px', lineHeight: 1.6, background: t.surfaceAlt, padding: '12px', borderRadius: '10px', color: t.textSub, whiteSpace: 'pre-wrap' }}>{ticket.description}</p>
//             </div>
//             {ticket.screenshot && (
//               <div style={{ marginBottom: '20px' }}>
//                 <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: t.text }}>Screenshot</h4>
//                 <img src={ticket.screenshot} alt="screenshot" style={{ maxWidth: '100%', borderRadius: '8px' }} />
//               </div>
//             )}
//             <div style={{ marginBottom: '20px' }}>
//               <h4 style={{ margin: '0 0 12px 0', fontSize: '13px', color: t.text }}>💬 Reply</h4>
//               <textarea rows="3" placeholder="Type your reply..." value={replyText} onChange={(e) => setReplyText(e.target.value)} style={{ width: '100%', padding: '12px', background: t.surfaceAlt, border: `1px solid ${t.border}`, borderRadius: '10px', fontSize: '13px', resize: 'vertical', color: t.text }} />
//             </div>
//             <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', paddingTop: '10px', borderTop: `1px solid ${t.border}` }}>
//               <button onClick={onClose} style={{ padding: '8px 16px', borderRadius: '8px', border: `1px solid ${t.border}`, background: t.surfaceAlt, color: t.textMuted, cursor: 'pointer' }}>Close</button>
//               {ticket.ticketstatus !== 'resolved' && ticket.ticketstatus !== 'closed' && (
//                 <button onClick={() => handleResolve(ticket.id)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: t.success, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}><ResolveIcon /> Resolve</button>
//               )}
//               <button onClick={() => { handleReply(ticket.id, replyText); }} style={{ padding: '8px 20px', borderRadius: '8px', border: 'none', background: t.accent, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}><SendIcon /> Send Reply</button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div style={{ minHeight: '100vh', background: t.bg, fontFamily: "'DM Sans', sans-serif" }}>
//       <div style={{ padding: '20px 24px' }}>
//         <div style={{ marginBottom: '24px' }}>
//           <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 700, color: t.text }}>Support Tickets</h1>
//           <p style={{ margin: '4px 0 0', fontSize: '13px', color: t.textMuted }}>
//             {isAdmin ? 'Admin view – all tickets' : 'Your restaurant tickets'}
//           </p>
//         </div>

//         {/* Stats */}
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
//           <Card style={{ background: t.surface, border: `1px solid ${t.border}`, borderRadius: '16px', padding: '16px', textAlign: 'center' }}>
//             <div style={{ fontSize: '28px', fontWeight: 700, color: t.text }}>{stats.total}</div>
//             <div style={{ fontSize: '12px', color: t.textMuted }}>Total</div>
//           </Card>
//           <Card style={{ background: t.surface, border: `1px solid ${t.border}`, borderRadius: '16px', padding: '16px', textAlign: 'center' }}>
//             <div style={{ fontSize: '28px', fontWeight: 700, color: t.danger }}>{stats.open}</div>
//             <div style={{ fontSize: '12px', color: t.textMuted }}>Open</div>
//           </Card>
//           <Card style={{ background: t.surface, border: `1px solid ${t.border}`, borderRadius: '16px', padding: '16px', textAlign: 'center' }}>
//             <div style={{ fontSize: '28px', fontWeight: 700, color: t.info }}>{stats.inProgress}</div>
//             <div style={{ fontSize: '12px', color: t.textMuted }}>In Progress</div>
//           </Card>
//           <Card style={{ background: t.surface, border: `1px solid ${t.border}`, borderRadius: '16px', padding: '16px', textAlign: 'center' }}>
//             <div style={{ fontSize: '28px', fontWeight: 700, color: t.success }}>{stats.resolved}</div>
//             <div style={{ fontSize: '12px', color: t.textMuted }}>Resolved</div>
//           </Card>
//         </div>

//         {/* Search & Filter (Admin extra filter) */}
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
//           <div style={{ position: 'relative', width: '280px' }}>
//             <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }}>🔍</span>
//             <input type="text" placeholder="Search tickets..." value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: '100%', padding: '10px 12px 10px 35px', background: t.surface, border: `1px solid ${t.border}`, borderRadius: '10px', fontSize: '13px', color: t.text }} />
//           </div>
//           <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
//             {isAdmin && (
//               <select value={userTable} onChange={(e) => setUserTable(e.target.value)} style={{ padding: '8px 12px', background: t.surface, border: `1px solid ${t.border}`, borderRadius: '8px', fontSize: '12px', color: t.text }}>
//                 <option value="restaurants">Restaurants</option>
//                 <option value="users">Users</option>
//                 <option value="riders">Riders</option>
//               </select>
//             )}
//             <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={{ padding: '8px 12px', background: t.surface, border: `1px solid ${t.border}`, borderRadius: '8px', fontSize: '12px', color: t.text }}>
//               <option value="all">All Status</option>
//               <option value="open">Open</option>
//               <option value="pending">Pending</option>
//               <option value="in_progress">In Progress</option>
//               <option value="resolved">Resolved</option>
//               <option value="closed">Closed</option>
//             </select>
//           </div>
//         </div>

//         {/* List */}
//         <div style={{ maxHeight: 'calc(100vh - 420px)', overflowY: 'auto' }}>
//           {loading ? (
//             <div style={{ textAlign: 'center', padding: '40px', color: t.textMuted }}>Loading...</div>
//           ) : error ? (
//             <div style={{ textAlign: 'center', padding: '40px', color: t.danger }}>{error}</div>
//           ) : paginatedTickets.length === 0 ? (
//             <div style={{ textAlign: 'center', padding: '40px', color: t.textMuted }}>No tickets found</div>
//           ) : (
//             paginatedTickets.map(ticket => (
//               <TicketCard
//                 key={ticket.id}
//                 ticket={ticket}
//                 onClick={() => { setSelectedTicket(ticket); setShowTicketModal(true); }}
//                 isDark={isDark}
//               />
//             ))
//           )}
//         </div>

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '20px', paddingTop: '20px', borderTop: `1px solid ${t.border}` }}>
//             <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={{ width: '32px', height: '32px', borderRadius: '8px', border: `1px solid ${t.border}`, background: t.surface, cursor: 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}><ChevronLeftIcon /></button>
//             <span style={{ fontSize: '12px', color: t.text }}>{currentPage} / {totalPages}</span>
//             <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} style={{ width: '32px', height: '32px', borderRadius: '8px', border: `1px solid ${t.border}`, background: t.surface, cursor: 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}><ChevronRightIcon /></button>
//           </div>
//         )}

//         {showTicketModal && selectedTicket && (
//           <TicketDetailModal ticket={selectedTicket} onClose={() => setShowTicketModal(false)} />
//         )}
//       </div>
//     </div>
//   );
// };

// export default SupportSystem;

// import React, { useState, useEffect } from 'react';
// import { getData, postData, putData } from '../../../Services/Fetchnodeservices';

// // --- Icons ---
// const PlusIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
// const CloseIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

// const getT = (isDark) => ({
//   bg: isDark ? "#0c1018" : "#f8fafc",
//   surface: isDark ? "#141824" : "#ffffff",
//   border: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0",
//   text: isDark ? "#f1f5f9" : "#0f172a",
//   textMuted: isDark ? "#94a3b8" : "#64748b",
//   accent: "#6366f1",
//   success: "#22c55e",
//   danger: "#ef4444"
// });

// const StatusBadge = ({ status }) => {
//   const colors = {
//     open: { bg: "#fee2e2", text: "#ef4444" },
//     in_progress: { bg: "#dbeafe", text: "#3b82f6" },
//     resolved: { bg: "#dcfce7", text: "#22c55e" },
//     closed: { bg: "#f1f5f9", text: "#64748b" }
//   };
//   const style = colors[status] || colors.open;
//   return <span style={{ padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 600, backgroundColor: style.bg, color: style.text, textTransform: 'capitalize' }}>{status}</span>;
// };

// const SupportSystem = ({ isDark = true, restaurantId = null, isAdmin = false }) => {
//   const t = getT(isDark);
//   const [tickets, setTickets] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [selectedTicket, setSelectedTicket] = useState(null);
//   const [statusFilter, setStatusFilter] = useState('all');
  
//   // Form State for new ticket
//   const [newTicket, setNewTicket] = useState({ subject: '', description: '' });

//   const fetchTickets = async () => {
//     setLoading(true);
//     try {
//       let url = `supportRoutes?status=${statusFilter}`;
//       if (!isAdmin && restaurantId) {
//         url += `&user_table=restaurants&user_id=${restaurantId}`;
//       }
//       const res = await getData(url);
//       if (res.success) setTickets(res.data);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchTickets(); }, [statusFilter, restaurantId]);

//   const handleCreateTicket = async () => {
//     if (!newTicket.subject || !newTicket.description) return alert("Fields missing");
//     const body = {
//       ...newTicket,
//       user_table: isAdmin ? 'admin' : 'restaurants',
//       user_id: restaurantId || 0,
//     };
//     const res = await postData('supportRoutes/create', body);
//     if (res.success) {
//       setShowCreateModal(false);
//       setNewTicket({ subject: '', description: '' });
//       fetchTickets();
//     }
//   };

//   const handleUpdateStatus = async (id, newStatus) => {
//     const res = await putData(`supportRoutes/update/${id}`, { ticketstatus: newStatus });
//     if (res.success) {
//       setSelectedTicket(null);
//       fetchTickets();
//     }
//   };

//   return (
//     <div style={{ padding: '24px', background: t.bg, minHeight: '100vh', color: t.text, fontFamily: 'sans-serif' }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
//         <div>
//           <h1 style={{ fontSize: '24px', margin: 0 }}>Support Desk</h1>
//           <p style={{ color: t.textMuted, fontSize: '14px' }}>Manage and track help requests</p>
//         </div>
//         <button 
//           onClick={() => setShowCreateModal(true)}
//           style={{ background: t.accent, color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
//         >
//           <PlusIcon /> New Ticket
//         </button>
//       </div>

//       {/* Filters */}
//       <div style={{ marginBottom: '20px' }}>
//         {['all', 'open', 'in_progress', 'resolved'].map(f => (
//           <button key={f} onClick={() => setStatusFilter(f)} style={{ marginRight: '8px', padding: '6px 12px', borderRadius: '6px', border: `1px solid ${t.border}`, background: statusFilter === f ? t.accent : t.surface, color: statusFilter === f ? '#fff' : t.text, cursor: 'pointer', textTransform: 'capitalize' }}>{f}</button>
//         ))}
//       </div>

//       {/* Ticket List */}
//       <div style={{ display: 'grid', gap: '12px' }}>
//         {loading ? <p>Loading...</p> : tickets.map(ticket => (
//           <div key={ticket.id} onClick={() => setSelectedTicket(ticket)} style={{ background: t.surface, padding: '16px', borderRadius: '12px', border: `1px solid ${t.border}`, cursor: 'pointer' }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//               <span style={{ fontWeight: 600 }}>{ticket.subject}</span>
//               <StatusBadge status={ticket.ticketstatus} />
//             </div>
//             <p style={{ fontSize: '13px', color: t.textMuted, margin: '8px 0' }}>{ticket.description.substring(0, 100)}...</p>
//             <div style={{ fontSize: '11px', color: t.textMuted }}>ID: #{ticket.id} • {new Date(ticket.created_at).toLocaleDateString()}</div>
//           </div>
//         ))}
//       </div>

//       {/* Create Modal */}
//       {showCreateModal && (
//         <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
//           <div style={{ background: t.surface, width: '400px', padding: '24px', borderRadius: '16px' }}>
//             <h3>Create Ticket</h3>
//             <input placeholder="Subject" style={{ width: '100%', padding: '10px', marginBottom: '12px', borderRadius: '8px', border: `1px solid ${t.border}`, background: t.bg, color: t.text }} onChange={e => setNewTicket({...newTicket, subject: e.target.value})} />
//             <textarea placeholder="Description" rows={4} style={{ width: '100%', padding: '10px', marginBottom: '12px', borderRadius: '8px', border: `1px solid ${t.border}`, background: t.bg, color: t.text }} onChange={e => setNewTicket({...newTicket, description: e.target.value})} />
//             <div style={{ display: 'flex', gap: '10px' }}>
//               <button onClick={() => setShowCreateModal(false)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: `1px solid ${t.border}`, cursor: 'pointer' }}>Cancel</button>
//               <button onClick={handleCreateTicket} style={{ flex: 1, padding: '10px', background: t.accent, color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Submit</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Detail Modal */}
//       {selectedTicket && (
//         <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
//           <div style={{ background: t.surface, width: '500px', padding: '24px', borderRadius: '16px' }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//               <h3>Ticket Detail</h3>
//               <button onClick={() => setSelectedTicket(null)} style={{ background: 'none', border: 'none', color: t.text }}><CloseIcon /></button>
//             </div>
//             <p><strong>Subject:</strong> {selectedTicket.subject}</p>
//             <div style={{ background: t.bg, padding: '12px', borderRadius: '8px', fontSize: '14px' }}>{selectedTicket.description}</div>
            
//             {isAdmin && (
//               <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
//                 <button onClick={() => handleUpdateStatus(selectedTicket.id, 'in_progress')} style={{ background: '#3b82f6', color: '#fff', border: 'none', padding: '8px 12px', borderRadius: '6px', cursor: 'pointer' }}>Mark In-Progress</button>
//                 <button onClick={() => handleUpdateStatus(selectedTicket.id, 'resolved')} style={{ background: '#22c55e', color: '#fff', border: 'none', padding: '8px 12px', borderRadius: '6px', cursor: 'pointer' }}>Resolve</button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SupportSystem;
// src/pages/SupportSystem.js
import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from '../../../../context/ThemeContext';
import { getData, postData, putData, serverURL } from '../../../../services/Fetchnodeservices';
import usePermissions from '../../../../hooks/usePermissions';

// ===== Icons =====
const PlusIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const CloseIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const TicketIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
    <path d="M13 5v2M13 17v2M13 11v2" />
  </svg>
);

// ===== Status Badge (Theme-Aware) =====
const StatusBadge = ({ status, theme }) => {
  const colors = {
    open: { bg: `${theme.error || theme.danger}1a`, text: theme.error || theme.danger },
    in_progress: { bg: `${theme.primary}1a`, text: theme.primary },
    resolved: { bg: `${theme.success}1a`, text: theme.success },
    closed: { bg: `${theme.textMuted}1a`, text: theme.textMuted }
  };
  const style = colors[status] || colors.open;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '11px',
      fontWeight: 600,
      backgroundColor: style.bg,
      color: style.text,
      textTransform: 'capitalize'
    }}>
      <span style={{
        width: '5px',
        height: '5px',
        borderRadius: '50%',
        background: style.text,
      }} />
      {status === 'in_progress' ? 'In Progress' : status}
    </span>
  );
};

// ===== StatCard Component (Theme-Aware) =====
const StatCard = ({ icon, label, val, color, theme }) => (
  <div style={{
    background: theme.surface,
    padding: '20px',
    borderRadius: '16px',
    border: `1px solid ${theme.border}`,
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    boxShadow: `0 4px 12px ${theme.primary}08`,
    transition: 'transform 0.2s, box-shadow 0.2s',
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = `0 8px 25px ${color}1a`;
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}08`;
  }}
  >
    <div style={{
      width: '48px',
      height: '48px',
      borderRadius: '12px',
      background: `${color}15`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '22px',
      color: color
    }}>
      {icon}
    </div>
    <div>
      <div style={{ fontSize: '26px', fontWeight: 700, color: theme.textPrimary }}>{val}</div>
      <div style={{ color: theme.textMuted, fontSize: '13px' }}>{label}</div>
    </div>
  </div>
);

// ===== Main Component =====
const SupportSystem = ({ isAdmin = true, restaurantId = null }) => {
  const { theme } = useContext(ThemeContext); // ← Theme Context
  const { hasPermission } = usePermissions();

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [statusFilter, setStatusFilter] = useState('all');
  const [sourceFilter, setSourceFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newTicket, setNewTicket] = useState({ subject: '', description: '' });

  // Check if user has permission to create tickets
  const canCreateTicket = hasPermission('app_support.tickets') || isAdmin;

  // Fetch Tickets
  const fetchTickets = async () => {
    setLoading(true);
    try {
      let url = `supportRoutes?status=${statusFilter}&user_table=${sourceFilter}&search=${search}`;
      if (!isAdmin && restaurantId) {
        url += `&user_table=restaurants&user_id=${restaurantId}`;
      }
      const res = await getData(url);
      if (res.success) setTickets(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, [statusFilter, sourceFilter, restaurantId]);

  // Update status
  const updateStatus = async (id, newStatus) => {
    try {
      const res = await putData(`supportRoutes/update/${id}`, { ticketstatus: newStatus });
      if (res.success) {
        fetchTickets();
        if (selectedTicket && selectedTicket.id === id) {
          setSelectedTicket({ ...selectedTicket, ticketstatus: newStatus });
        }
      }
    } catch (err) { console.error(err); }
  };

  // Create ticket
  const handleCreateTicket = async () => {
    if (!newTicket.subject || !newTicket.description) {
      alert('Subject & description required');
      return;
    }
    const body = {
      ...newTicket,
      user_table: isAdmin ? 'admin' : 'restaurants',
      user_id: restaurantId || 0,
    };
    const res = await postData('supportRoutes/create', body);
    if (res.success) {
      setShowCreateModal(false);
      setNewTicket({ subject: '', description: '' });
      fetchTickets();
    }
  };

  // Stats
  const stats = {
    total: tickets.length,
    open: tickets.filter(t => t.ticketstatus === 'open').length,
    in_progress: tickets.filter(t => t.ticketstatus === 'in_progress').length,
    closed: tickets.filter(t => t.ticketstatus === 'closed' || t.ticketstatus === 'resolved').length,
  };

  // Source tabs data
  const sourceTabs = [
    { key: 'all', label: 'All Tickets', count: stats.total, icon: '🎫' },
    { key: 'users', label: 'Users', icon: '👤' },
    { key: 'restaurants', label: 'Restaurants', icon: '🍽️' },
    { key: 'riders', label: 'Riders', icon: '🚴' },
  ];

  return (
    <div style={{
      padding: '24px',
      background: theme.background,
      minHeight: '100vh',
      color: theme.textPrimary,
      fontFamily: "'DM Sans', sans-serif",
      transition: 'background 0.3s ease'
    }}>
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }
      `}</style>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ fontSize: '26px', fontWeight: 700, margin: 0, color: theme.textPrimary, display: 'flex', alignItems: 'center', gap: '10px' }}>
            🎫 Support Tickets
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: theme.textMuted }}>
            Manage and track support requests
          </p>
        </div>
        {canCreateTicket && (
          <button
            onClick={() => setShowCreateModal(true)}
            style={{
              background: theme.primary,
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontWeight: 500,
              fontSize: '14px',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: `0 4px 12px ${theme.primary}40`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 8px 25px ${theme.primary}60`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
            }}
          >
            <PlusIcon /> New Ticket
          </button>
        )}
      </div>

      {/* Stats */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
        marginBottom: '30px'
      }}>
        <StatCard icon="💬" label="Total" val={stats.total} color={theme.primary} theme={theme} />
        <StatCard icon="⚠️" label="Open" val={stats.open} color={theme.error || theme.danger} theme={theme} />
        <StatCard icon="🕒" label="In Progress" val={stats.in_progress} color={theme.warning} theme={theme} />
        <StatCard icon="✅" label="Closed" val={stats.closed} color={theme.success} theme={theme} />
      </div>

      {/* Source Filters (only for admin) */}
      {isAdmin && (
        <div style={{
          display: 'flex',
          gap: '8px',
          marginBottom: '25px',
          flexWrap: 'wrap',
          padding: '6px',
          background: theme.surface,
          border: `1px solid ${theme.border}`,
          borderRadius: '12px',
          width: 'fit-content',
        }}>
          {sourceTabs.map(tab => (
            <button
              key={tab.key}
              style={{
                padding: '10px 20px',
                borderRadius: '8px',
                background: sourceFilter === tab.key ? theme.primary : 'transparent',
                border: 'none',
                color: sourceFilter === tab.key ? '#fff' : theme.textSecondary,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '13px',
                fontWeight: 500,
                transition: 'all 0.2s',
              }}
              onClick={() => setSourceFilter(tab.key)}
              onMouseEnter={(e) => {
                if (sourceFilter !== tab.key) {
                  e.currentTarget.style.background = theme.surfaceLighter;
                  e.currentTarget.style.color = theme.textPrimary;
                }
              }}
              onMouseLeave={(e) => {
                if (sourceFilter !== tab.key) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = theme.textSecondary;
                }
              }}
            >
              <span>{tab.icon}</span>
              {tab.label}
              {tab.count !== undefined && (
                <span style={{
                  background: sourceFilter === tab.key ? 'rgba(255,255,255,0.2)' : `${theme.primary}1a`,
                  color: sourceFilter === tab.key ? '#fff' : theme.primary,
                  padding: '1px 8px',
                  borderRadius: '12px',
                  fontSize: '11px',
                  fontWeight: 700,
                }}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>
      )}

      {/* Search & Status Filter */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px',
        flexWrap: 'wrap',
        gap: '12px'
      }}>
        <div style={{ display: 'flex', gap: '10px', flex: '1', maxWidth: '500px' }}>
          <div style={{ position: 'relative', flex: 1 }}>
            <span style={{
              position: 'absolute',
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: theme.textMuted,
              display: 'flex',
              alignItems: 'center',
            }}>
              <SearchIcon />
            </span>
            <input
              style={{
                background: theme.surface,
                border: `1px solid ${theme.border}`,
                color: theme.textPrimary,
                padding: '10px 16px 10px 38px',
                borderRadius: '10px',
                outline: 'none',
                fontSize: '14px',
                width: '100%',
                transition: 'border-color 0.2s, box-shadow 0.2s',
                boxSizing: 'border-box',
              }}
              placeholder="Search subject or description..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && fetchTickets()}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = theme.primary;
                e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = theme.border;
                e.currentTarget.style.boxShadow = 'none';
              }}
            />
          </div>
          <button
            onClick={fetchTickets}
            style={{
              background: theme.primary,
              color: '#fff',
              border: 'none',
              padding: '0 24px',
              borderRadius: '10px',
              cursor: 'pointer',
              fontWeight: 500,
              transition: 'transform 0.2s, box-shadow 0.2s',
              whiteSpace: 'nowrap',
              boxShadow: `0 4px 12px ${theme.primary}30`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 8px 25px ${theme.primary}50`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}30`;
            }}
          >
            Search
          </button>
        </div>
        <div style={{
          background: theme.surface,
          border: `1px solid ${theme.border}`,
          padding: '4px',
          borderRadius: '10px',
          display: 'flex',
          gap: '4px',
          flexWrap: 'wrap'
        }}>
          {['all', 'open', 'in_progress', 'closed'].map(f => (
            <button
              key={f}
              onClick={() => setStatusFilter(f)}
              style={{
                background: statusFilter === f ? theme.primary : 'transparent',
                color: statusFilter === f ? '#fff' : theme.textSecondary,
                border: 'none',
                padding: '8px 16px',
                borderRadius: '7px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 500,
                textTransform: 'capitalize',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                if (statusFilter !== f) {
                  e.currentTarget.style.background = theme.surfaceLighter;
                  e.currentTarget.style.color = theme.textPrimary;
                }
              }}
              onMouseLeave={(e) => {
                if (statusFilter !== f) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = theme.textSecondary;
                }
              }}
            >
              {f === 'all' ? 'All' : f === 'in_progress' ? 'In Progress' : f}
            </button>
          ))}
        </div>
      </div>

      {/* Table */}
      <div style={{
        background: theme.surface,
        borderRadius: '16px',
        border: `1px solid ${theme.border}`,
        overflow: 'hidden',
        boxShadow: `0 4px 12px ${theme.primary}08`
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '80px 200px 1fr 150px 150px 130px',
          padding: '14px 20px',
          background: theme.surfaceLighter,
          color: theme.primary,
          fontSize: '11px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          borderBottom: `1px solid ${theme.border}`
        }}>
          <span>ID</span>
          <span>Source</span>
          <span>Subject</span>
          <span>Status</span>
          <span>Date</span>
          <span>Action</span>
        </div>
        {loading && (
          <div style={{ padding: '40px', textAlign: 'center', color: theme.textMuted }}>
            <div style={{
              display: 'inline-block',
              width: '40px',
              height: '40px',
              border: `3px solid ${theme.border}`,
              borderTop: `3px solid ${theme.primary}`,
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
            <div style={{ marginTop: '12px', fontSize: '14px' }}>Loading tickets...</div>
          </div>
        )}
        {!loading && tickets.length === 0 && (
          <div style={{ padding: '60px 40px', textAlign: 'center', color: theme.textMuted }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: `${theme.primary}1a`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
              color: theme.primary,
            }}>
              <TicketIcon />
            </div>
            <h3 style={{ margin: '0 0 8px', color: theme.textPrimary, fontSize: '16px', fontWeight: 600 }}>No tickets found</h3>
            <p style={{ margin: '8px 0 0', fontSize: '14px' }}>
              {statusFilter !== 'all' ? `No ${statusFilter} tickets available` : 'All tickets are resolved'}
            </p>
          </div>
        )}
        {tickets.map(t => (
          <div
            key={t.id}
            style={{
              display: 'grid',
              gridTemplateColumns: '80px 200px 1fr 150px 150px 130px',
              padding: '14px 20px',
              borderBottom: `1px solid ${theme.border}`,
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background 0.15s',
              background: selectedTicket?.id === t.id ? `${theme.primary}08` : theme.surface,
            }}
            onClick={() => setSelectedTicket(t)}
            onMouseEnter={(e) => {
              if (selectedTicket?.id !== t.id) {
                e.currentTarget.style.background = theme.surfaceHover || theme.surfaceLighter;
              }
            }}
            onMouseLeave={(e) => {
              if (selectedTicket?.id !== t.id) {
                e.currentTarget.style.background = theme.surface;
              }
            }}
          >
            <span style={{ color: theme.primary, fontWeight: 700, fontFamily: 'monospace' }}>#{t.id}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                background: `${theme.primary}15`,
                color: theme.primary,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px'
              }}>👤</div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: 500, color: theme.textPrimary }}>
                  {t.user_id || 'N/A'}
                </div>
                <div style={{ fontSize: '11px', color: theme.textMuted, textTransform: 'capitalize' }}>{t.user_table}</div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: theme.textPrimary, fontSize: '13px' }}>
              <span>{t.subject}</span>
              {t.screenshot && <span style={{ color: theme.textMuted, fontSize: '13px' }}>📎</span>}
            </div>
            <div><StatusBadge status={t.ticketstatus} theme={theme} /></div>
            <div style={{ fontSize: '12px', color: theme.textMuted }}>
              {new Date(t.created_at).toLocaleDateString()}
            </div>
            {isAdmin ? (
              <select
                style={{
                  background: theme.surface,
                  color: theme.textPrimary,
                  border: `1px solid ${theme.border}`,
                  borderRadius: '6px',
                  padding: '6px 10px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  outline: 'none',
                }}
                value={t.ticketstatus}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => updateStatus(t.id, e.target.value)}
              >
                <option value="open">Open</option>
                <option value="in_progress">In Progress</option>
                <option value="closed">Closed</option>
                <option value="resolved">Resolved</option>
              </select>
            ) : (
              <StatusBadge status={t.ticketstatus} theme={theme} />
            )}
          </div>
        ))}
      </div>

      {/* Create Modal */}
      {showCreateModal && (
        <div style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.7)',
          backdropFilter: 'blur(4px)',
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'fadeIn 0.2s ease'
        }}
          onClick={() => setShowCreateModal(false)}
        >
          <div style={{
            background: theme.surface,
            width: '440px',
            padding: '32px',
            borderRadius: '20px',
            boxShadow: `0 20px 60px ${theme.primary}30`,
            animation: 'slideUp 0.3s ease',
            maxWidth: '90vw',
            border: `1px solid ${theme.border}`,
          }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ marginTop: 0, marginBottom: '8px', color: theme.textPrimary, fontSize: '20px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <PlusIcon /> Create New Ticket
            </h3>
            <p style={{ color: theme.textMuted, fontSize: '13px', marginBottom: '20px' }}>
              Submit a new support request
            </p>
            <input
              placeholder="Subject"
              style={{
                background: theme.surfaceLighter,
                border: `1px solid ${theme.border}`,
                color: theme.textPrimary,
                padding: '11px 14px',
                borderRadius: '10px',
                outline: 'none',
                fontSize: '14px',
                width: '100%',
                marginBottom: '14px',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s',
              }}
              value={newTicket.subject}
              onChange={e => setNewTicket({ ...newTicket, subject: e.target.value })}
              onFocus={(e) => e.currentTarget.style.borderColor = theme.primary}
              onBlur={(e) => e.currentTarget.style.borderColor = theme.border}
            />
            <textarea
              placeholder="Description"
              rows={4}
              style={{
                background: theme.surfaceLighter,
                border: `1px solid ${theme.border}`,
                color: theme.textPrimary,
                padding: '11px 14px',
                borderRadius: '10px',
                outline: 'none',
                fontSize: '14px',
                width: '100%',
                marginBottom: '18px',
                resize: 'vertical',
                fontFamily: 'inherit',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s',
              }}
              value={newTicket.description}
              onChange={e => setNewTicket({ ...newTicket, description: e.target.value })}
              onFocus={(e) => e.currentTarget.style.borderColor = theme.primary}
              onBlur={(e) => e.currentTarget.style.borderColor = theme.border}
            />
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={() => setShowCreateModal(false)}
                style={{
                  flex: 1,
                  padding: '12px',
                  borderRadius: '10px',
                  border: `1px solid ${theme.border}`,
                  background: 'transparent',
                  color: theme.textPrimary,
                  cursor: 'pointer',
                  fontWeight: 500,
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = theme.surfaceLighter}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                Cancel
              </button>
              <button
                onClick={handleCreateTicket}
                style={{
                  flex: 1,
                  padding: '12px',
                  borderRadius: '10px',
                  background: theme.primary,
                  color: '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 600,
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: `0 4px 12px ${theme.primary}40`,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = `0 8px 25px ${theme.primary}60`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
                }}
              >
                Submit Ticket
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Side Drawer */}
      {selectedTicket && (
        <>
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.7)',
              backdropFilter: 'blur(4px)',
              zIndex: 999,
              animation: 'fadeIn 0.2s ease'
            }}
            onClick={() => setSelectedTicket(null)}
          />
          <div style={{
            position: 'fixed',
            right: 0,
            top: 0,
            width: '480px',
            maxWidth: '100vw',
            height: '100vh',
            background: theme.surface,
            borderLeft: `1px solid ${theme.border}`,
            padding: '30px',
            zIndex: 1000,
            boxShadow: `-10px 0 30px ${theme.primary}20`,
            overflowY: 'auto',
            animation: 'slideInRight 0.3s ease',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '25px' }}>
              <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                <div style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: `${theme.primary}15`,
                  color: theme.primary,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '20px'
                }}>👤</div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '18px', color: theme.textPrimary, fontWeight: 700 }}>
                    Ticket <span style={{ color: theme.primary, fontFamily: 'monospace' }}>#{selectedTicket.id}</span>
                  </h3>
                  <small style={{ color: theme.textMuted, textTransform: 'capitalize' }}>
                    {selectedTicket.user_table} — User {selectedTicket.user_id}
                  </small>
                </div>
              </div>
              <button
                onClick={() => setSelectedTicket(null)}
                style={{
                  background: theme.surfaceLighter,
                  border: `1px solid ${theme.border}`,
                  color: theme.textMuted,
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = `${theme.error || theme.danger}1a`;
                  e.currentTarget.style.color = theme.error || theme.danger;
                  e.currentTarget.style.borderColor = theme.error || theme.danger;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = theme.surfaceLighter;
                  e.currentTarget.style.color = theme.textMuted;
                  e.currentTarget.style.borderColor = theme.border;
                }}
              >
                <CloseIcon />
              </button>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' }}>
              <StatusBadge status={selectedTicket.ticketstatus} theme={theme} />
              <span style={{ fontSize: '13px', color: theme.textMuted, display: 'flex', alignItems: 'center', gap: '4px' }}>
                📅 {new Date(selectedTicket.created_at).toLocaleString()}
              </span>
            </div>

            <div style={{
              background: theme.surfaceLighter,
              padding: '16px',
              borderRadius: '12px',
              marginBottom: '16px',
              border: `1px solid ${theme.border}`,
            }}>
              <small style={{ color: theme.textMuted, fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Subject</small>
              <div style={{ fontWeight: 600, marginTop: '6px', color: theme.textPrimary, fontSize: '15px' }}>
                {selectedTicket.subject}
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <small style={{ color: theme.textMuted, fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Description</small>
              <div style={{
                background: theme.surfaceLighter,
                padding: '14px',
                borderRadius: '12px',
                marginTop: '6px',
                lineHeight: 1.6,
                color: theme.textSecondary,
                fontSize: '14px',
                border: `1px solid ${theme.border}`,
              }}>
                {selectedTicket.description}
              </div>
            </div>

            {selectedTicket.screenshot && (
              <div style={{ marginBottom: '20px' }}>
                <small style={{ color: theme.textMuted, fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Attachment</small>
                <img
                  src={`${serverURL}/uploads/${selectedTicket.screenshot}`}
                  alt="attachment"
                  style={{
                    width: '100%',
                    height: 200,
                    objectFit: 'contain',
                    borderRadius: '12px',
                    marginTop: '6px',
                    border: `1px solid ${theme.border}`,
                    background: theme.surfaceLighter
                  }}
                />
              </div>
            )}

            {isAdmin && (
              <div style={{
                marginTop: 'auto',
                paddingTop: '20px',
                borderTop: `1px solid ${theme.border}`
              }}>
                <small style={{ color: theme.textMuted, fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Update Status</small>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginTop: '10px' }}>
                  {['open', 'in_progress', 'closed', 'resolved'].map(st => (
                    <button
                      key={st}
                      onClick={() => updateStatus(selectedTicket.id, st)}
                      style={{
                        padding: '10px',
                        borderRadius: '8px',
                        border: `1px solid ${selectedTicket.ticketstatus === st ? theme.success : theme.border}`,
                        background: selectedTicket.ticketstatus === st ? `${theme.success}15` : 'transparent',
                        color: selectedTicket.ticketstatus === st ? theme.success : theme.textPrimary,
                        cursor: 'pointer',
                        textTransform: 'capitalize',
                        fontSize: '13px',
                        fontWeight: 500,
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        if (selectedTicket.ticketstatus !== st) {
                          e.currentTarget.style.background = theme.surfaceLighter;
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedTicket.ticketstatus !== st) {
                          e.currentTarget.style.background = 'transparent';
                        }
                      }}
                    >
                      {st === 'in_progress' ? 'In Progress' : st}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SupportSystem;